/* Golfspil-generator – vanilla JS, ingen dependencies */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'gg-spil-';

  /* ---------- Spilbibliotek ---------- */
  /* team: 'hold' | 'individuel' | 'begge'
     mood: 'sjov' | 'serioes' | 'begge'
     settings: hvilke anledninger spillet passer til
     teamSizes: foretrukne holdstørrelser
     countRule:
       - 'pairs': kræver et lige antal spillere og komplette par
       - 'two-equal-teams': kræver et lige antal spillere fordelt på to lige store hold */

  var GAMES = [
    { name: 'Texas Scramble', min: 4, max: 99, team: 'hold', teamSizes: [4, 3, 2], mood: 'sjov',
      settings: ['firmagolf', 'hyggerunde', 'turnering', 'herreklub'],
      desc: 'Den mest sociale holdspilleform, hvor alle niveauer kan bidrage.',
      rules: 'Alle på holdet slår fra tee. I vælger den bedste bold, og alle spiller videre derfra. Sådan fortsætter I, til bolden er i hul. Kræv evt. at hver spillers drive skal bruges mindst 2-3 gange.',
      scoring: 'Laveste samlede holdscore vinder. Spil evt. med holdhandicap efter turneringens egne betingelser.' },

    { name: 'Stableford', min: 1, max: 99, team: 'individuel', mood: 'begge',
      settings: ['turnering', 'herreklub', 'hyggerunde'],
      desc: 'Standardformatet i danske klubturneringer – tilgivende og hurtigt.',
      rules: 'Du får point pr. hul ud fra dit handicap: 2 point for netto-par, 3 for netto-birdie og 1 for netto-bogey. Kan du ikke score point på et hul, kan du samle bolden op og gå videre.',
      scoring: 'Flest point efter runden vinder.' },

    { name: 'Slagspil', min: 1, max: 99, team: 'individuel', mood: 'serioes',
      settings: ['turnering', 'herreklub'],
      desc: 'Det klassiske turneringsformat, hvor hvert eneste slag tæller.',
      rules: 'Alle slag tælles på alle huller, og bolden skal i hul hver gang. Spilles typisk brutto eller netto afhængigt af turneringens betingelser.',
      scoring: 'Laveste totale score vinder – brutto eller netto.' },

    { name: 'Matchplay', min: 2, max: 2, team: 'individuel', mood: 'serioes',
      settings: ['hyggerunde', 'turnering'],
      desc: 'Duellen spiller mod spiller, hvor hvert hul er en lille finale.',
      rules: 'I spiller om hvert hul: Laveste score vinder hullet. Står det lige, deles hullet. Matchen er afgjort, når en spiller fører med flere huller, end der er tilbage. Tildelte slag fordeles efter hullernes stroke index.',
      scoring: 'Resultatet angives som fx "3&2" – 3 huller foran med 2 tilbage.' },

    { name: 'Best Ball (Better Ball)', min: 4, max: 99, team: 'hold', teamSizes: [2], countRule: 'pairs', mood: 'begge',
      settings: ['hyggerunde', 'turnering', 'herreklub'],
      desc: 'Parspil, hvor I spiller jeres egne bolde – kun den bedste tæller.',
      rules: 'Begge spillere på parret spiller deres egen bold hele hullet. Parrets score på hullet er den bedste af de to. Spilles ofte som Stableford, hvor bedste pointscore tæller.',
      scoring: 'Bedste score pr. hul lægges sammen – laveste total eller flest point vinder.' },

    { name: 'Greensome', min: 4, max: 99, team: 'hold', teamSizes: [2], countRule: 'pairs', mood: 'begge',
      settings: ['turnering', 'hyggerunde', 'herreklub'],
      desc: 'Parspil med fælles bold – men begge slår ud.',
      rules: 'Begge spillere driver på hvert hul. I vælger den bedste drive og spiller derefter skiftevis på samme bold, til den er i hul.',
      scoring: 'Én fælles score pr. hul. Brug den handicapberegning, som turneringens betingelser angiver.' },

    { name: 'Foursome', min: 4, max: 99, team: 'hold', teamSizes: [2], countRule: 'pairs', mood: 'serioes',
      settings: ['turnering', 'herreklub'],
      desc: 'Det klassiske Ryder Cup-format med én bold pr. par.',
      rules: 'Parret spiller én bold og slår skiftevis – også fra tee, hvor den ene driver på lige huller og den anden på ulige. Kræver samarbejde og is i maven.',
      scoring: 'Én fælles score pr. hul, ofte spillet som matchplay mod et andet par.' },

    { name: 'Ryder Cup-format', min: 6, max: 99, team: 'hold', countRule: 'two-equal-teams', mood: 'begge',
      settings: ['herreklub', 'turnering', 'firmagolf'],
      desc: 'To lige store hold mødes i en serie matcher – med masser af holdånd.',
      rules: 'Del gruppen i to lige store hold, og sæt matcherne op som en blanding af foursomes, best ball og singler. Hver vundet match giver 1 point til holdet, og delte matcher giver ½ point til hver.',
      scoring: 'Holdet med flest matchpoint efter alle matcher vinder cuppen.' },

    { name: 'Skins', min: 2, max: 4, team: 'individuel', mood: 'sjov',
      settings: ['hyggerunde'],
      desc: 'Hvert hul har en præmie – og puljen vokser, når ingen vinder.',
      rules: 'Hvert hul er en "skin". Laveste score alene vinder hullets skin. Deler to eller flere spillere den laveste score, overføres skin\'en til næste hul, som så er dobbelt værd.',
      scoring: 'Flest skins efter runden vinder. Aftal værdien pr. skin på forhånd.' },

    { name: 'Bingo Bango Bongo', min: 2, max: 4, team: 'individuel', mood: 'sjov',
      settings: ['hyggerunde'],
      desc: 'Tre point i spil på hvert hul – også høje handicaps kan vinde.',
      rules: 'Der gives 1 point for først på green (bingo), 1 point for tættest på flaget, når alle er på green (bango), og 1 point for først i hul (bongo). Spil i korrekt rækkefølge – længst fra hullet spiller først.',
      scoring: 'Flest point efter 18 huller vinder.' },

    { name: 'Wolf', min: 4, max: 4, team: 'begge', mood: 'sjov',
      settings: ['hyggerunde'],
      desc: 'Taktisk firebold, hvor "ulven" vælger makker – eller går solo.',
      rules: 'Spillerne skiftes til at være ulv og driver sidst på hullet. Efter hver drive kan ulven vælge den spiller som makker – eller gå "lone wolf" mod de tre andre for dobbelte point. Hullet spilles som best ball.',
      scoring: 'Vinderen af hullet får point – flest point efter runden vinder.' },

    { name: 'Vegas', min: 4, max: 4, team: 'hold', teamSizes: [2], countRule: 'pairs', mood: 'sjov',
      settings: ['hyggerunde'],
      desc: 'Parspil med talkombinationer, hvor det kan svinge vildt.',
      rules: 'To par spiller mod hinanden. Parrets scorer kombineres til ét tal med laveste score først: 4 og 5 bliver 45. Forskellen mellem de to tal er hullets pointudsving.',
      scoring: 'Forskellen i kombinerede tal lægges til eller trækkes fra løbende. Aftal en fast værdi pr. point.' },

    { name: 'Chapman (Pinehurst)', min: 4, max: 99, team: 'hold', teamSizes: [2], countRule: 'pairs', mood: 'begge',
      settings: ['turnering', 'hyggerunde'],
      desc: 'Parformat med et twist: I bytter bolde efter drivet.',
      rules: 'Begge spillere driver, hvorefter I spiller hinandens bolde på andet slag. Derefter vælger I den bedste bold og spiller skiftevis, til den er i hul.',
      scoring: 'Én fælles score pr. hul – laveste total vinder.' },

    { name: 'Nassau', min: 2, max: 4, team: 'begge', mood: 'sjov',
      settings: ['hyggerunde'],
      desc: 'Tre matcher i én runde: front 9, back 9 og totalen.',
      rules: 'Runden deles op i tre separate konkurrencer – de første 9 huller, de sidste 9 og hele runden. Hver del afgøres som matchplay eller på score.',
      scoring: 'Tre selvstændige vindere. Aftal formatet på forhånd.' },

    { name: 'Flagturnering', min: 3, max: 99, team: 'individuel', mood: 'sjov',
      settings: ['turnering', 'firmagolf', 'herreklub'],
      desc: 'Alle får et antal slag – hvor langt når du, før de slipper op?',
      rules: 'Hver spiller får banens par plus sit spillehandicap i slag. Når dine slag er brugt, planter du dit flag dér, hvor din sidste bold ligger.',
      scoring: 'Spilleren, hvis flag står længst fremme på banen, vinder.' },

    { name: 'Snake (puttespil)', min: 2, max: 4, team: 'individuel', mood: 'sjov',
      settings: ['hyggerunde'],
      desc: 'Et sideløbende puttespil, der straffer tre-putts.',
      rules: 'Den, der senest har lavet tre putts, holder "slangen". Laver en anden spiller tre putts, sendes slangen videre. Spilles typisk oven i en almindelig runde.',
      scoring: 'Aftal på forhånd, hvad det betyder at holde slangen efter sidste hul.' },

    { name: 'String-spil', min: 4, max: 99, team: 'begge', mood: 'sjov',
      settings: ['firmagolf'],
      desc: 'Hver spiller får en snor – og klipper sig til bedre leje.',
      rules: 'Alle får en aftalt længde snor. Snoren kan bruges til at flytte bolden – ud af rough, op af bunker eller helt i hul. Den brugte længde klippes af.',
      scoring: 'Spilles oven på fx Stableford eller scramble. Når snoren er brugt, er der ingen hjælp tilbage.' }
  ];

  var SIDEGAMES = [
    'Tilføj "nærmest flaget" på et par 3-hul – vinderen kåres efter runden.',
    'Tilføj "længste drive" på et bredt par 5-hul.',
    'Sælg mulligans før start: 1-2 ekstra slag pr. spiller, der kan bruges frit.',
    'Spil Snake ved siden af: Den, der senest har lavet tre putts, får den aftalte konsekvens efter runden.',
    'Kår dagens "Most Honest Golfer" – flest slag i alt – med en lille trøstepræmie.'
  ];

  /* ---------- Hjælpere ---------- */

  function teamLabel(t) {
    if (t === 'hold') return 'Holdspil';
    if (t === 'individuel') return 'Individuelt';
    return 'Hold eller individuelt';
  }

  function playerLabel(g) {
    if (g.max >= 99) return g.min + '+ spillere';
    if (g.min === g.max) return 'Præcis ' + g.min + ' spillere';
    return g.min + '\u2013' + g.max + ' spillere';
  }

  function supportsPlayerCount(g, count) {
    if (count < g.min || count > g.max) return false;
    if (g.countRule === 'pairs') return count % 2 === 0;
    if (g.countRule === 'two-equal-teams') return count % 2 === 0;
    return true;
  }

  function teamSuggestion(g, count) {
    if (!count) return '';

    if (g.countRule === 'pairs') {
      return 'Med ' + count + ' spillere: ' + (count / 2) + ' komplette par à 2 spillere.';
    }

    if (g.countRule === 'two-equal-teams') {
      return 'Med ' + count + ' spillere: 2 lige store hold à ' + (count / 2) + ' spillere.';
    }

    if (g.team !== 'hold' || !g.teamSizes) return '';

    for (var i = 0; i < g.teamSizes.length; i++) {
      var s = g.teamSizes[i];
      if (count % s === 0 && count / s >= 2) {
        return 'Med ' + count + ' spillere: ' + (count / s) + ' hold à ' + s + '.';
      }
    }

    var preferredSize = g.teamSizes[0];
    var teams = Math.max(2, Math.round(count / preferredSize));
    var base = Math.floor(count / teams);
    var extra = count % teams;
    if (base < 1) return '';

    var sizes = extra > 0 ? base + ' og ' + (base + 1) : String(base);
    var note = extra > 0
      ? ' Holdene bliver ulige i størrelse, så overvej en individuel spilleform eller en roterende spiller.'
      : '';

    return 'Med ' + count + ' spillere: ' + teams + ' hold med ' + sizes + ' spillere pr. hold.' + note;
  }

  /* ---------- Matching ---------- */

  function findMatches(count, setting, teamPref, mood) {
    var results = [];

    GAMES.forEach(function (g) {
      if (!supportsPlayerCount(g, count)) return;
      if (teamPref !== 'begge' && g.team !== 'begge' && g.team !== teamPref) return;

      var score = 0;
      if (g.settings.indexOf(setting) !== -1) score += 3;
      if (mood !== 'begge') {
        if (g.mood === mood) score += 2;
        else if (g.mood === 'begge') score += 1;
      } else {
        score += 1;
      }
      if (teamPref !== 'begge' && g.team === teamPref) score += 1;

      results.push({ game: g, score: score + Math.random() * 0.5 });
    });

    results.sort(function (a, b) { return b.score - a.score; });
    return results.map(function (r) { return r.game; });
  }

  /* ---------- Instans ---------- */

  function initInstance(root) {
    if (root.dataset.ggReady === 'true') return;
    root.dataset.ggReady = 'true';

    var sectionId = root.getAttribute('data-section-id') || 'default';
    var storageKey = STORAGE_PREFIX + sectionId;

    var form = root.querySelector('[data-gg-form]');
    var countInput = root.querySelector('[data-gg-count]');
    var settingSel = root.querySelector('[data-gg-setting]');
    var teamSel = root.querySelector('[data-gg-team]');
    var moodSel = root.querySelector('[data-gg-mood]');
    var errorsBox = root.querySelector('[data-gg-errors]');
    var results = root.querySelector('[data-gg-results]');
    var nameEl = root.querySelector('[data-gg-name]');
    var metaEl = root.querySelector('[data-gg-meta]');
    var descEl = root.querySelector('[data-gg-desc]');
    var rulesEl = root.querySelector('[data-gg-rules]');
    var scoringEl = root.querySelector('[data-gg-scoring]');
    var sidegameEl = root.querySelector('[data-gg-sidegame]');
    var altsWrap = root.querySelector('[data-gg-alts-wrap]');
    var altsList = root.querySelector('[data-gg-alts]');
    var feedbackEl = root.querySelector('[data-gg-feedback]');

    if (!form || !countInput) return;

    var matches = [];
    var currentIndex = 0;
    var currentCount = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function saveState() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify({
          count: countInput.value,
          setting: settingSel.value,
          team: teamSel.value,
          mood: moodSel.value
        }));
      } catch (e) { /* ignorér */ }
    }

    function restoreState() {
      try {
        var data = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
        if (!data) return;
        if (data.count) countInput.value = String(data.count);
        if (data.setting) settingSel.value = data.setting;
        if (data.team) teamSel.value = data.team;
        if (data.mood) moodSel.value = data.mood;
      } catch (e) { /* ignorér */ }
    }

    function clearErrors() {
      errorsBox.textContent = '';
      countInput.classList.remove('gg-spil__input--error');
    }

    function showError(message) {
      clearErrors();
      var p = document.createElement('p');
      p.textContent = message;
      p.style.margin = '0';
      errorsBox.appendChild(p);
      countInput.classList.add('gg-spil__input--error');
      countInput.focus();
    }

    function renderCurrent() {
      var g = matches[currentIndex];
      if (!g) return;

      nameEl.textContent = g.name;
      metaEl.textContent = playerLabel(g) + ' · ' + teamLabel(g.team);
      descEl.textContent = g.desc;
      rulesEl.textContent = g.rules;

      var scoringText = 'Pointsystem: ' + g.scoring;
      var suggestion = teamSuggestion(g, currentCount);
      scoringEl.textContent = suggestion ? scoringText + ' ' + suggestion : scoringText;

      if (moodSel.value === 'sjov' || settingSel.value === 'firmagolf') {
        sidegameEl.textContent = 'Ekstra krydderi: ' + SIDEGAMES[Math.floor(Math.random() * SIDEGAMES.length)];
        sidegameEl.hidden = false;
      } else {
        sidegameEl.hidden = true;
        sidegameEl.textContent = '';
      }

      altsList.textContent = '';
      var altCount = 0;
      for (var i = 0; i < matches.length && altCount < 2; i++) {
        if (i === currentIndex) continue;
        var alt = matches[i];
        var li = document.createElement('li');
        var strong = document.createElement('strong');
        strong.textContent = alt.name;
        var span = document.createElement('span');
        span.textContent = alt.desc + ' (' + playerLabel(alt) + ')';
        li.appendChild(strong);
        li.appendChild(span);
        altsList.appendChild(li);
        altCount++;
      }
      altsWrap.hidden = altCount === 0;

      results.hidden = false;
      if (!reducedMotion) {
        results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function find() {
      clearErrors();
      feedbackEl.textContent = '';

      var raw = countInput.value.trim();
      var count = parseInt(raw, 10);

      if (raw === '' || !/^\d+$/.test(raw)) {
        showError('Indtast antal spillere som et helt tal, fx 8.');
        return;
      }
      if (count < 1) {
        showError('Antal spillere skal mindst være 1.');
        return;
      }
      if (count > 200) {
        showError('Indtast et antal spillere mellem 1 og 200.');
        return;
      }

      currentCount = count;
      matches = findMatches(count, settingSel.value, teamSel.value, moodSel.value);

      if (matches.length === 0) {
        matches = findMatches(count, settingSel.value, 'begge', 'begge');
        if (matches.length === 0) {
          showError('Ingen spilleform matcher præcis ' + count + ' spillere. Prøv et andet antal.');
          return;
        }
        feedbackEl.textContent = 'Ingen spilleform matchede alle ønsker – her er det tætteste gyldige bud.';
      }

      currentIndex = 0;
      saveState();
      renderCurrent();
    }

    function buildShareText() {
      var g = matches[currentIndex];
      if (!g) return '';
      var lines = [
        'Spilleform: ' + g.name,
        playerLabel(g) + ' · ' + teamLabel(g.team),
        '',
        'Sådan spiller I: ' + g.rules,
        'Pointsystem: ' + g.scoring
      ];
      var suggestion = teamSuggestion(g, currentCount);
      if (suggestion) lines.push(suggestion);
      lines.push('');
      lines.push('Fundet med golfspil-generatoren på golfgodter93.shop');
      return lines.join('\n');
    }

    function copyResult() {
      var text = buildShareText();
      if (!text) return;

      function done(ok) {
        feedbackEl.textContent = ok
          ? 'Forslaget er kopieret – klar til Messenger, Facebook eller e-mail.'
          : 'Kunne ikke kopiere automatisk. Markér teksten og kopiér manuelt.';
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () { done(true); }, function () { fallbackCopy(text, done); });
      } else {
        fallbackCopy(text, done);
      }
    }

    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      ta.remove();
      done(ok);
    }

    function resetAll() {
      countInput.value = '';
      settingSel.value = 'hyggerunde';
      teamSel.value = 'begge';
      moodSel.value = 'begge';
      matches = [];
      currentIndex = 0;
      currentCount = 0;
      results.hidden = true;
      feedbackEl.textContent = '';
      clearErrors();
      try { window.localStorage.removeItem(storageKey); } catch (e) { /* ignorér */ }
      countInput.focus();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      find();
    });

    root.querySelector('[data-gg-next]').addEventListener('click', function () {
      if (matches.length < 2) {
        feedbackEl.textContent = 'Der er ikke flere gyldige forslag til de valgte kriterier.';
        return;
      }
      feedbackEl.textContent = '';
      currentIndex = (currentIndex + 1) % matches.length;
      renderCurrent();
    });

    root.querySelector('[data-gg-copy]').addEventListener('click', copyResult);
    root.querySelector('[data-gg-reset]').addEventListener('click', resetAll);

    countInput.addEventListener('input', saveState);
    settingSel.addEventListener('change', saveState);
    teamSel.addEventListener('change', saveState);
    moodSel.addEventListener('change', saveState);

    restoreState();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gg-spil]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();